import { MLM, NOT_SET, TrackingParameter } from '@sunrise/tracking'

import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { CompanyName, TypePaid } from '../../ts/utils/trackingUtils.enum'

import { ContactBtnPosition } from './MsDetailContactBtnGroup.enum'

const staticTealiumData = {
    mslayer_element_company_name: NOT_SET,
    mslayer_element_count: NOT_SET,
    mslayer_element_data_id: TealiumTrackingIds.DETAIL_ACTIONS,
    mslayer_element_detail_start_date: NOT_SET,
    mslayer_element_position: NOT_SET,
    mslayer_element_text: 'immobilien_expose',
    mslayer_element_variant: 'lightbox_open',
}

export function buildMlmTrackingData(
    componentId: string,
    currentUrl: string,
    exposeeId: number,
    isContactModal: boolean,
): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId: isContactModal ? ActionIds.OPEN_MODAL_CONTACT : ActionIds.OPEN_MODAL_CALL,
        componentId,
        pageUrl: currentUrl,
        items: [buildMlmItems(exposeeId)],
    }
}

export function buildTealiumTrackingData(
    exposeeId: number,
    position: ContactBtnPosition,
    isContactModal: boolean,
    adType: string,
): TrackingParameter {
    const baseData: TrackingParameter = {
        ...staticTealiumData,
        mslayer_element_body_type: determineBodyTypeByPosition(position),
        mslayer_element_id: exposeeId.toString(),
        mslayer_element_type_text: isContactModal ? 'kontaktieren_email' : 'kontaktieren_anruf',
    }

    if (!isContactModal) {
        baseData.mslayer_element_ad_type = adType
    }

    return baseData
}

function buildMlmItems(exposeeId: number): MLM.Item {
    return {
        id: exposeeId.toString(),
        type: CompanyName.OWN_INVENTORY,
        typePaid: TypePaid.OWN_INVENTORY,
        typePosition: 1,
    }
}

function determineBodyTypeByPosition(position: ContactBtnPosition): string {
    switch (position) {
        case ContactBtnPosition.CONTACT_INFO_TOP:
            return 'text_body_upper'
        case ContactBtnPosition.CONTACT_INFO_BOTTOM:
            return 'text_body_lower'
        case ContactBtnPosition.STICKY_BAR:
            return 'stickybar'
    }
}
